import { ApiError, NetworkError } from '../api/client';
import { Screen } from './Frame';

/**
 * Экраны входа, которые не получились. Ветвление — строго по `code`:
 * тексты меняются, и код, завязанный на `message`, ломается от правки
 * формулировки.
 */

type Copy = { title: string; body: string };

const COPY: Record<string, Copy> = {
  TENANT_REQUIRED: {
    title: 'Не понятно, какая это организация',
    body: 'Откройте приложение по ссылке из бота вашей организации — в ней зашито, к какой организации вы относитесь.',
  },
  TENANT_NOT_FOUND: {
    title: 'Организация не найдена',
    body: 'Ссылка ведёт на организацию, которой больше нет. Попросите администратора прислать новую.',
  },
  TENANT_ARCHIVED: {
    title: 'Организация закрыта',
    body: 'Организация больше не работает в приложении. По вопросам о записях свяжитесь с администратором.',
  },
  TENANT_SUSPENDED: {
    title: 'Организация временно приостановлена',
    body: 'Доступ к приложению закрыт до возобновления подписки. Уже созданные записи в силе — уточните детали у администратора.',
  },
  BAD_INIT_DATA: {
    title: 'Не удалось подтвердить вход',
    body: 'Telegram не подтвердил, что это вы. Закройте приложение и откройте его заново из бота.',
  },
  INIT_DATA_REQUIRED: {
    title: 'Приложение открыто не из Telegram',
    body: 'Откройте его кнопкой в боте организации: вход подтверждается подписью Telegram.',
  },
  NETWORK: {
    title: 'Нет связи с сервером',
    body: 'Проверьте интернет и попробуйте ещё раз. Если связь есть, значит, сервер сейчас недоступен.',
  },
};

const FALLBACK: Copy = {
  title: 'Что-то пошло не так',
  body: 'Не получилось открыть приложение. Попробуйте позже или напишите администратору организации.',
};

export function ErrorScreen({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const code = error instanceof ApiError ? error.code : error instanceof NetworkError ? 'NETWORK' : 'UNKNOWN';
  const copy = COPY[code] ?? FALLBACK;

  return (
    <Screen className="fail success">
      <div className="seal">
        <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 4l9 16H3z" />
          <path d="M12 10v4M12 17h.01" />
        </svg>
      </div>
      <h2>{copy.title}</h2>
      <p>{copy.body}</p>
      {onRetry ? (
        <button className="btn" style={{ maxWidth: 220 }} onClick={onRetry}>
          Попробовать ещё раз
        </button>
      ) : null}
      <p className="footnote">
        <code>{code}</code>
      </p>
    </Screen>
  );
}

/** Экран загрузки: без спиннера-обманки, просто полоса как в прототипе. */
export function LoadingScreen() {
  return (
    <Screen>
      <p className="eyebrow">Загрузка</p>
      <div className="load">
        <i style={{ width: '40%' }} />
      </div>
    </Screen>
  );
}
